import axios from "axios";

// const rootUrl = "http://www.hhaq.icu:8080/wx/WebAuthorization"
//
// const baseURL = "http://www.hhaq.icu:8080";

//const baseURL = "http://localhost:8080";

export function goRoot() {
    window.location.replace(window.configs.rootUrl)
    // window.location.replace(rootUrl)
}

// axios.defaults.baseURL = baseURL;
axios.defaults.baseURL = window.configs.baseUrl;

axios.defaults.headers.post["Content-Type"] =
    "application/x-www-form-urlencoded;charset=UTF-8";

axios.defaults.timeout = 50000;

axios.interceptors.request.use(
    config => {
        return config;
    },
    error => {
        return Promise.reject(error);
    }
);

axios.interceptors.response.use(
    response => {
        return response;
    },
    error => {
        return Promise.reject(error);
    }
);

function post(url, params) {
    return new Promise((resolve, reject) => {
        axios
            .post(url, params)
            .then(
                response => {
                    resolve(response);
                },
                err => {
                    reject(err);
                }
            )
            .catch(error => {
                reject(error);
            });
    });
}

function get(url, param) {
    return new Promise((resolve, reject) => {
        axios
            .get(url, {params: param})
            .then(
                response => {
                    resolve(response);
                },
                err => {
                    reject(err);
                }
            )
            .catch(error => {
                reject(error);
            });
    });
}

function upload(url, param) {
    return new Promise((resolve, reject) => {
        axios
            .post(url, param, {headers: {"Content-Type": "multipart/form-data"}})
            .then(
                response => {
                    resolve(response);
                },
                err => {
                    reject(err);
                }
            )
            .catch(error => {
                reject(error);
            });
    });
}

export default {
    get,
    post,
    upload,
};
